import React from 'react';
import ReactDOM from 'react-dom';
import { FiCheckCircle } from "react-icons/fi";
import { FaCircleExclamation } from "react-icons/fa6";
// import { PiDotOutlineDuotone } from "react-icons/pi";

const SuccessAlert = ({ msg, onClose }) => {
  const [isVisible, setIsVisible] = React.useState(true);

  const handleClickOutside = (e) => {
    if (e.target.id === 'overlay') {
      setIsVisible(false);
      onClose && onClose();
    }
  };

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      onClose && onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!isVisible) return null;

  return (
    <div
      id="overlay"
      className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center z-50"
      onClick={handleClickOutside}
    >
      <div
        className="rounded-xl relative max-w-[50%] md:max-w-[40%] lg:max-w-[30%]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => {
            setIsVisible(false);
            onClose && onClose();
          }}
          className="absolute top-2 right-2 text-gray-600 hover:text-black text-xl font-bold"
        >
          &times;
        </button>
        <div className='flex bg-white pt-5 p-3 px-8  flex-col justify-center items-center gap-2 rounded-t-xl'>
          <div className='text-lg md:text-xl lg:text-5xl w-fit bg-emerald-500 text-white rounded-full -mt-20 p-2'>
            <FiCheckCircle />
          </div>
          <div className='text-lg mt-3 bg-white lg:text-2xl font-poppins font-bold text-green-700'>SUCCESS</div>
        </div>
        <div className='px-8 pb-5 rounded-b-xl text-center text-base lg:text-lg bg-white text-black'>
          <p>{msg}</p>
        </div>
        <div className='mx-[5%] bg-emerald-500 p-1 rounded-b-xl'></div>
      </div>
    </div>
  );
};

const ErrorAlert = ({ msg, onClose }) => {
  const [isVisible, setIsVisible] = React.useState(true);

  const handleClickOutside = (e) => {
    if (e.target.id === 'overlay') {
      setIsVisible(false);
      onClose && onClose();
    }
  };

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      onClose && onClose();
    }, 7000);
    return () => clearTimeout(timer);
  }, [onClose]);

  if (!isVisible) return null;

  return (
    <div
      id="overlay"
      className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center z-50"
      onClick={handleClickOutside}
    >
      <div
        className="rounded-xl relative max-w-[65%] md:max-w-[50%] lg:max-w-[35%]"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={() => {
            setIsVisible(false);
            onClose && onClose();
          }}
          className="absolute top-2 right-2 text-gray-600 hover:text-black text-xl font-bold"
        >
          &times;
        </button>
        <div className='flex bg-white pt-5 p-3 px-8  flex-col justify-center items-center gap-2 rounded-t-xl'>
          <div className='text-lg md:text-xl lg:text-5xl w-fit bg-red-500 text-white rounded-full -mt-20 p-2'>
            <FaCircleExclamation />
          </div>
          <div className='text-lg mt-3 bg-white lg:text-2xl font-poppins font-bold text-red-700'>ERROR</div>
        </div>
        <div className='px-8 pb-5 rounded-b-xl text-base lg:text-lg bg-white max-h-64 overflow-y-auto'>
          {
            !(typeof msg === 'object' && msg !== null && !Array.isArray(msg))
              ? <p>{msg ? msg : "Network Issue"}</p>
              : (
                (msg !== null && msg && Array.isArray(Object.keys(msg)) && Object.keys(msg)?.length > 0)
                  ? Object.keys(msg)?.map((key, index) => (
                    <div key={index} className='inline'>
                      <span className="font-medium text-red-800 whitespace-nowrap">{key && key?.replace(/_/g, ' ').replace(/\b\w/g, (char) => char?.toUpperCase())}:&nbsp;</span>
                      {/* <p className='mt-0.5'><PiDotOutlineDuotone /></p> */}
                      <div className="text-black flex flex-wrap items-start">
                        {(Array.isArray(msg[key]) && msg[key]?.length > 0) && msg[key]?.map((error, i) => (
                          <span key={i}>{error}</span>
                        ))}
                      </div>
                    </div>
                  ))
                  : <p>{msg ? msg : "Network Issue"}</p>
              )
          }
        </div>
        <div className='mx-[5%] bg-red-500 p-1 rounded-b-xl'></div>
      </div>
    </div>
  );
};

export const Alert = {
  SuccessAlert: (msg) => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const closeAlert = () => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
    };

    ReactDOM.render(
      <SuccessAlert msg={msg} onClose={closeAlert} />,
      container
    );
  },

  ErrorAlert: (msg) => {
    const container = document.createElement('div');
    document.body.appendChild(container);

    const closeAlert = () => {
      ReactDOM.unmountComponentAtNode(container);
      document.body.removeChild(container);
    };

    ReactDOM.render(
      <ErrorAlert msg={msg} onClose={closeAlert} />,
      container
    );
  },
};
